import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["value", "id", "name", "disabled", "placeholder", "min", "max", "step"]
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import { useIdGenerator } from '@/shared/designsystem/useIdGenerator';
import { useVModel } from '@vueuse/core';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-number-input',
},
  __name: 'number-input',
  props: {
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  name: {
    type: String,
  },
  modelValue: {
    type: Number,
    required: true,
  },
  placeholder: {
    type: String,
  },
  min: {
    type: Number,
  },
  max: {
    type: Number,
  },
  step: {
    type: Number,
  },
  errorMessage: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  hideLabel: {
    type: String,
  },
},
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {



const props = __props;

const { inputId } = useIdGenerator(props.id);

const emit = __emit;

const value = useVModel(props, 'modelValue', emit);

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  value.value = input.value === '' ? (props.min ?? 0) : Number(input.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-input", { 'has-error': __props.errorMessage }])
  }, [
    _createElementVNode("label", {
      for: _unref(inputId),
      class: _normalizeClass({ 'sr-only': __props.hideLabel })
    }, _toDisplayString(__props.label), 11, _hoisted_1),
    _createElementVNode("input", {
      class: "control",
      type: "number",
      value: _unref(value),
      id: _unref(inputId),
      name: __props.name,
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      min: __props.min,
      max: __props.max,
      step: __props.step,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event))),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', _unref(value))))
    }, null, 40, _hoisted_2),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})